var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 88,
    viewBox: "0 0 226 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 10.75V87.25",
    stroke: "url(#paint0_linear_1172_6298)",
    strokeOpacity: 0.1,
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.75 10.75V87.25",
    stroke: "url(#paint1_linear_1172_6298)",
    strokeOpacity: 0.2,
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.75 10.75V87.25",
    stroke: "url(#paint2_linear_1172_6298)",
    strokeOpacity: 0.25,
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.75 10.75V87.25",
    stroke: "url(#paint3_linear_1172_6298)",
    strokeOpacity: 0.25,
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.75 10.75V87.25",
    stroke: "url(#paint4_linear_1172_6298)",
    strokeOpacity: 0.3,
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.75 10.75V87.25",
    stroke: "url(#paint5_linear_1172_6298)",
    strokeOpacity: 0.6,
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.75 10.75V87.25",
    stroke: "url(#paint6_linear_1172_6298)",
    strokeOpacity: 0.6,
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M139.75 10.75V87.25",
    stroke: "url(#paint7_linear_1172_6298)",
    strokeOpacity: 0.3,
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M157.75 10.75V87.25",
    stroke: "url(#paint8_linear_1172_6298)",
    strokeOpacity: 0.25,
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M175.75 10.75V87.25",
    stroke: "url(#paint9_linear_1172_6298)",
    strokeOpacity: 0.25,
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M193.75 10.75V87.25",
    stroke: "url(#paint10_linear_1172_6298)",
    strokeOpacity: 0.2,
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M211.75 10.75V87.25",
    stroke: "url(#paint11_linear_1172_6298)",
    strokeOpacity: 0.1,
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.75 24.75C103.75 23.6454 104.645 22.75 105.75 22.75H119.75C120.855 22.75 121.75 23.6454 121.75 24.75V48.75H103.75V24.75Z",
    fill: "url(#paint12_linear_1172_6298)",
    fillOpacity: 0.8
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.75 7.75C67.75 6.64543 68.6454 5.75 69.75 5.75H83.75C84.8546 5.75 85.75 6.64543 85.75 7.75V48.75H67.75V7.75Z",
    fill: "url(#paint13_linear_1172_6298)",
    fillOpacity: 0.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.75 2.75C31.75 1.64543 32.6454 0.75 33.75 0.75H47.75C48.8546 0.75 49.75 1.64543 49.75 2.75V48.75H31.75V2.75Z",
    fill: "url(#paint14_linear_1172_6298)",
    fillOpacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M175.75 15.75C175.75 14.6454 176.645 13.75 177.75 13.75H191.75C192.855 13.75 193.75 14.6454 193.75 15.75V48.75H175.75V15.75Z",
    fill: "url(#paint15_linear_1172_6298)",
    fillOpacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M139.75 19.75C139.75 18.6454 140.645 17.75 141.75 17.75H155.75C156.855 17.75 157.75 18.6454 157.75 19.75V48.75H139.75V19.75Z",
    fill: "url(#paint16_linear_1172_6298)",
    fillOpacity: 0.4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 14.75H225.25",
    stroke: "url(#paint17_linear_1172_6298)",
    strokeOpacity: 0.1,
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 31.75H225.25",
    stroke: "url(#paint18_linear_1172_6298)",
    strokeOpacity: 0.3,
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 48.75H225.25",
    stroke: "url(#paint19_linear_1172_6298)",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 65.75H225.25",
    stroke: "url(#paint20_linear_1172_6298)",
    strokeOpacity: 0.3,
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 82.75H225.25",
    stroke: "url(#paint21_linear_1172_6298)",
    strokeOpacity: 0.1,
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1172_6298",
    x1: 13.75,
    y1: 9.75,
    x2: 13.75,
    y2: 87.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A9B3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F5F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1172_6298",
    x1: 31.75,
    y1: 9.75,
    x2: 31.75,
    y2: 87.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A9B3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F5F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1172_6298",
    x1: 49.75,
    y1: 9.75,
    x2: 49.75,
    y2: 87.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A9B3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F5F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1172_6298",
    x1: 67.75,
    y1: 9.75,
    x2: 67.75,
    y2: 87.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A9B3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F5F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1172_6298",
    x1: 85.75,
    y1: 9.75,
    x2: 85.75,
    y2: 87.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A9B3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F5F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1172_6298",
    x1: 103.75,
    y1: 9.75,
    x2: 103.75,
    y2: 87.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A9B3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F5F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1172_6298",
    x1: 121.75,
    y1: 9.75,
    x2: 121.75,
    y2: 87.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A9B3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F5F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1172_6298",
    x1: 139.75,
    y1: 9.75,
    x2: 139.75,
    y2: 87.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A9B3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F5F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1172_6298",
    x1: 157.75,
    y1: 9.75,
    x2: 157.75,
    y2: 87.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A9B3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F5F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1172_6298",
    x1: 175.75,
    y1: 9.75,
    x2: 175.75,
    y2: 87.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A9B3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F5F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1172_6298",
    x1: 193.75,
    y1: 9.75,
    x2: 193.75,
    y2: 87.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A9B3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F5F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1172_6298",
    x1: 211.75,
    y1: 9.75,
    x2: 211.75,
    y2: 87.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A9B3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F5F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1172_6298",
    x1: 112.75,
    y1: 17.25,
    x2: 112.75,
    y2: 60.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1172_6298",
    x1: 76.75,
    y1: 5.75,
    x2: 76.75,
    y2: 98.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7E2ED",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B3BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1172_6298",
    x1: 40.75,
    y1: 0.75,
    x2: 40.75,
    y2: 104.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E5F1",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B3BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1172_6298",
    x1: 184.75,
    y1: 13.75,
    x2: 184.75,
    y2: 89.4477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E5F1",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B3BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1172_6298",
    x1: 148.75,
    y1: -1.25,
    x2: 148.75,
    y2: 69.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0EAF4",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B3BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1172_6298",
    x1: 0.75,
    y1: 15.25,
    x2: 225.25,
    y2: 15.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A9B3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F5F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1172_6298",
    x1: 0.75,
    y1: 32.25,
    x2: 225.25,
    y2: 32.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A9B3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F5F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1172_6298",
    x1: 0.75,
    y1: 49.25,
    x2: 225.25,
    y2: 49.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A9B3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F5F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1172_6298",
    x1: 0.75,
    y1: 66.25,
    x2: 225.25,
    y2: 66.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A9B3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F5F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1172_6298",
    x1: 0.75,
    y1: 83.25,
    x2: 225.25,
    y2: 83.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A9B3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F5F8",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoStats);
export default __webpack_public_path__ + "static/media/no-stats.b9c38e46e70d2fcbde010d7ae2226874.svg";
export { ForwardRef as ReactComponent };